import Cookies from "js-cookie";

const AUTH_TOKEN_COOKIE = "VIVAPILOT_AUTH_TOKEN";
const REFRESH_TOKEN_COOKIE = "VIVAPILOT_REFRESH_TOKEN";

export const setAuthTokens = ({ token, refreshToken }) => {
  Cookies.set(AUTH_TOKEN_COOKIE, token);
  Cookies.set(REFRESH_TOKEN_COOKIE, refreshToken);
};

export const getAuthTokens = () => ({
  token: Cookies.get(AUTH_TOKEN_COOKIE),
  refreshToken: Cookies.get(REFRESH_TOKEN_COOKIE),
});
